module.exports = __webpack_public_path__ + "img/theme12.f33c5117.png";